const protectionDataFaqs = [
    {
        id:"1",
        question : "Do You Offer Insurance for All of My Items?",
        answer :"Yes, as required by the Department of Transportation",
    },
    {
        id:"2",
        question : "Do I Need to Empty My Dresser Drawers?",
        answer :"Yes, we recommend that all furniture, including dressers, be emptied before your move to ensure safe and secure transport. However, if you have opted for our full packing service, our moving crew will handle this for you!",
    },
    {
        id:"3",
        question : "Can I Transport Jewelry and Important Documents with My Other Items?",
        answer :"No, we do not transport jewelry or important documents, and we cannot be held liable if these items are packed without our prior knowledge. We strongly advise you to pack them separately, store them securely during your move, and personally transport them to your new location.",
    },
]

export default protectionDataFaqs;